import { ViewStateTypes } from '@common/enums/viewstate-types';

import { SearchViewStateRecord } from './search-viewstate-record';

export class DraftSearchViewStateRecord extends SearchViewStateRecord {
    public initialize() {
        super.initialize();
        this.viewStateType = ViewStateTypes.DRAFTSEARCH;
    }
}
